const LIQUID_TOKEN_IN_ANY = /{[{%][^}%]*[%}]}/

export function urlContainsTokens(url: string): boolean {
    const urlToParse = String(url || '')
    if (!urlToParse.trim()) return false

    // Ensure parseable by URL
    const normalized = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(urlToParse) ? urlToParse : `https://${urlToParse}`

    let parsed: URL
    try {
        parsed = new URL(normalized)
    } catch {
        // Not a valid URL
        return false
    }

    // Strip port from host
    const hostname = parsed.host.replace(/:\d+$/, '')
    // Strip trailing slash and revert to decoded path (URL() automatically encodes)
    const pathname = decodeURIComponent(parsed.pathname.replace(/\/$/, ''))

    // 1) Token in hostname? -> fail
    if (hostname.match(LIQUID_TOKEN_IN_ANY)) return true

    // 2) Token in path? -> fail
    // Pathname excludes query/hash. Leading slash is fine.
    if (pathname.match(LIQUID_TOKEN_IN_ANY)) return true

    // 3) Tokens in search or hash are allowed
    return false
}
